module.exports = __webpack_public_path__ + "static/media/add-white.d1cc05ec.svg";